import axios from "axios";
import { useContext, useEffect, useState } from "react";
import {
  Alert,
  Button,
  Form,
  InputGroup,
  Modal,
  Spinner,
  Table,
  Badge,
} from "react-bootstrap";
import {
  FiCheckCircle,
  FiEdit2,
  FiImage,
  FiPlusCircle,
  FiSearch,
  FiTag,
  FiTrash2,
  FiX,
  FiXCircle,
  FiLayers,
  FiUser,
} from "react-icons/fi";
import "../../../assets/css/admin/screens/category/CategoryManagement.css";
import MyContext from "../../../contexts/AppContext";
import AdminMasterLayout from "../../../layouts/admin/AdminMasterLayout";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CategoryManagement = () => {
  const { baseUrl, regExpChecker, baseUrlForFiles, adminAuthToken } = useContext(MyContext);
  const [stats, setStats] = useState(null);
  const [showCatModal, setShowCatModal] = useState(false);
  const [editingCategory, setEditingCategory] = useState(false);
  const [categoryIdForUpdate, setCategoryIdForUpdate] = useState(null);
  const [name, setName] = useState("");
  const [status, setStatus] = useState("active");
  const [image, setImage] = useState(null);
  const [imageForEdit, setImageForEdit] = useState("");
  const [submitLoading, setSubmitLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [errors, setErrors] = useState({});
  const [categories, setCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSubCatModal, setShowSubCatModal] = useState(false);
  const [parentCategoryId, setParentCategoryId] = useState(null);
  const [parentCategoryName, setParentCategoryName] = useState("");
  const [subCatName, setSubCatName] = useState("");
  const [subCatSubmitLoading, setSubCatSubmitLoading] = useState(false);
  const [subCatError, setSubCatError] = useState("");

  const resetForm = () => {
    setCategoryIdForUpdate(null);
    setName("");
    setStatus("active");
    setImage(null);
    setImageForEdit("");
    setErrorMessage("");
    setEditingCategory(false);
    setErrors({});
  };
  const handleCloseCatModal = () => {
    setShowCatModal(false);
    resetForm();
  };
  const handleCreateClick = () => {
    setEditingCategory(false);
    resetForm();
    setShowCatModal(true);
  };
  const validateAll = () => {
    const newErrors = {};
    const nameErr = regExpChecker("categoryName", name);
    if (nameErr) newErrors.name = nameErr;
    return newErrors;
  };

  const addCategory = () => {
    const validationErrors = validateAll();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setSubmitLoading(true);
    const adminId = JSON.parse(localStorage.getItem("loggedInAdmin"))?.id;
    const formdata = new FormData();
    formdata.append("chadmin_id", adminId);
    formdata.append("category_name", name);
    formdata.append("status", status);
    formdata.append("category_image", image);
    axios
      .post(`${baseUrl}/admin/category/addCategory`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${adminAuthToken}`,
        },
      })
      .then(() => {
        toast.success("Category Added");
        setSubmitLoading(false);
        viewAllCategories();
        handleCloseCatModal();
      })
      .catch((error) => {
        console.error(error);
        setErrorMessage("Something went wrong. Please try again.");
        setSubmitLoading(false);
      });
  };

  const updateCategory = () => {
    const validationErrors = validateAll();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setSubmitLoading(true);
    const adminId = JSON.parse(localStorage.getItem("loggedInAdmin"))?.id;
    const formdata = new FormData();
    formdata.append("chadmin_id", adminId);
    formdata.append("category_id", categoryIdForUpdate);
    formdata.append("category_name", name);
    formdata.append("status", status);
    formdata.append("category_image", image);
    axios
      .post(`${baseUrl}/admin/category/updateCategory`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${adminAuthToken}`,
        },
      })
      .then(() => {
        toast.info("Category Updated");
        setSubmitLoading(false);
        viewAllCategories();
        viewCategoryStats();
        handleCloseCatModal();
      })
      .catch((error) => {
        console.error(error);
        setErrorMessage("Something went wrong. Please try again.");
        setSubmitLoading(false);
      });
  };

  const viewAllCategories = () => {
    setLoading(true);
    const adminId = JSON.parse(localStorage.getItem("loggedInAdmin"))?.id;
    axios
      .get(`${baseUrl}/admin/category/viewAllCategories`, {
        headers: { Authorization: `Bearer ${adminAuthToken}` },
        params: { chadmin_id: adminId },
      })
      .then((response) => {
        setCategories(response.data.categories);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const viewCategoryStats = () => {
    const adminId = JSON.parse(localStorage.getItem("loggedInAdmin"))?.id;
    axios
      .get(`${baseUrl}/admin/category/stats`, {
        headers: { Authorization: `Bearer ${adminAuthToken}` },
        params: { chadmin_id: adminId },
      })
      .then((response) => {
        setStats(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteCategory = (id) => {
    const formdata = new FormData();
    formdata.append("category_id", id);
    axios
      .post(`${baseUrl}/admin/category/deleteCategory`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${adminAuthToken}`,
        },
      })
      .then(() => {
        toast.error("Category Deleted");
        viewAllCategories();
        viewCategoryStats();
      })
      .catch((error) => console.log(error));
  };

  const createsubcategory = () => {
    setSubCatSubmitLoading(true);
    const adminId = JSON.parse(localStorage.getItem("loggedInAdmin"))?.id;
    const formdata = new FormData();
    formdata.append("chadmin_id", adminId);
    formdata.append("category_id", parentCategoryId);
    formdata.append("subcategoryname", subCatName);
    axios
      .post(`${baseUrl}/admin/subcategory/createsubcategory`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${adminAuthToken}`,
        },
      })
      .then(() => {
        toast.success("Sub Category Added");
        viewAllCategories();
        viewCategoryStats();
        setSubCatSubmitLoading(false);
        closeSubCatModal();
      })
      .catch((error) => {
        console.error(error);
        setSubCatError("Something went wrong. Please try again.");
        setSubCatSubmitLoading(false);
      });
  };

  const activeCategory = (id) => {
    const formdata = new FormData();
    formdata.append("category_id", id);
    axios
      .post(`${baseUrl}/admin/category/activeCategory`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${adminAuthToken}`,
        },
      })
      .then(() => {
        toast.success("Category Active");
        viewAllCategories();
        viewCategoryStats();
      })
      .catch((error) => console.log(error));
  };

  const inactiveCategory = (id) => {
    const formdata = new FormData();
    formdata.append("category_id", id);
    axios
      .post(`${baseUrl}/admin/category/inactiveCategory`, formdata, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${adminAuthToken}`,
        },
      })
      .then(() => {
        toast.warning("Category Inactive");
        viewAllCategories();
        viewCategoryStats();
      })
      .catch((error) => console.log(error));
  };

  const openSubCatModal = (category) => {
    setParentCategoryId(category.id);
    setParentCategoryName(category.category_name);
    setSubCatName("");
    setSubCatError("");
    setShowSubCatModal(true);
  };
  const closeSubCatModal = () => {
    setShowSubCatModal(false);
    setParentCategoryId(null);
    setParentCategoryName("");
    setSubCatName("");
  };

  const filteredCategories = categories.filter((cat) =>
    cat.category_name?.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  useEffect(() => {
    viewAllCategories();
    viewCategoryStats();
  }, []);

  return (
    <AdminMasterLayout>
      <div className="cm-shell">
        <main className="cm-main">
          <section className="cm-card-shell">
            {/* ── Header ── */}
            <div className="cm-header-section">
              <div>
                <h3 className="cm-section-title">Category Management</h3>
                <p className="cm-section-subtitle">
                  Manage your product categories and subcategories
                </p>
              </div>
              <button className="cm-create-btn" onClick={handleCreateClick}>
                <span className="plus-icon">+</span> Create Category
              </button>
            </div>

            {/* ── Stat Cards ── */}
            <div className="cm-summary-grid">
              <div className="cm-summary-card">
                <div>
                  <span className="cm-label">Total Categories</span>
                  <h3>{stats?.total_categories ?? "0"}</h3>
                  <p className="cm-muted">All registered</p>
                </div>
                <div className="cm-card-icon">
                  <FiLayers size={22} />
                </div>
              </div>
              <div className="cm-summary-card">
                <div>
                  <span className="cm-label">Active Categories</span>
                  <h3>{stats?.active_categories ?? "0"}</h3>
                  <p className="cm-muted">Currently active</p>
                </div>
                <div className="cm-card-icon">
                  <FiCheckCircle size={22} />
                </div>
              </div>
              <div className="cm-summary-card">
                <div>
                  <span className="cm-label">Inactive Categories</span>
                  <h3>{stats?.inactive_categories ?? "0"}</h3>
                  <p className="cm-muted">Currently inactive</p>
                </div>
                <div className="cm-card-icon cm-card-icon-alert">
                  <FiXCircle size={22} />
                </div>
              </div>
            </div>

            {/* ── Toolbar ── */}
            <div className="cm-toolbar">
              <InputGroup className="cm-search-group">
                <InputGroup.Text className="input-group-text cm-search-icon">
                  <FiSearch size={14} />
                </InputGroup.Text>
                <Form.Control
                  type="text"
                  placeholder="Search categories..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="form-control cm-search-input"
                />
              </InputGroup>
            </div>

            {/* ── Table ── */}
            <div className="cm-layout">
              <div className="cm-table-wrapper">
                <Table className="cm-table mb-0">
                  <thead>
                    <tr>
                      <th>Image</th>
                      <th>Category Name</th>
                      <th>SubCategory</th>
                      <th>Total Products</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading && (
                      <tr>
                        <td colSpan="6" className="text-center py-4">
                          <Spinner
                            animation="border"
                            size="sm"
                            className="cm-spinner"
                          />
                          <span className="ms-2 cm-muted cm-loading-text">
                            Loading...
                          </span>
                        </td>
                      </tr>
                    )}
                    {!loading &&
                      filteredCategories.length > 0 &&
                      filteredCategories.map((category) => (
                        <tr key={category.id}>
                          <td>
                            {category.category_image ? (
                              <img
                                src={`${baseUrlForFiles}/${category.category_image}`}
                                alt={category.category_name}
                                className="cm-category-img"
                              />
                            ) : (
                              <span className="cm-muted">No Image</span>
                            )}
                          </td>
                          <td>
                            <span className="cm-name">
                              {category.category_name}
                            </span>
                          </td>
                          <td>
                            {category.subcategories?.length > 0 ? (
                              <ul>
                                {category.subcategories.map((sub) => (
                                  <li key={sub.id}>{sub.subcategoryname}</li>
                                ))}
                              </ul>
                            ) : (
                              <span className="cm-muted">No Subcategories</span>
                            )}
                          </td>
                          <td>
                            <span className="cm-product-count">
                              {category.products_count ?? 0}
                            </span>
                          </td>
                          <td>
                            <Badge
                              className={
                                category.status === "active"
                                  ? "badge-active"
                                  : "badge-inactive"
                              }
                            >
                              {category.status === "active"
                                ? "Active"
                                : "Inactive"}
                            </Badge>
                          </td>
                          <td>
                            <div className="cm-table-actions">
                              <Button
                                variant="success"
                                size="sm"
                                className="cm-action-btn"
                                title="Active"
                                onClick={() => activeCategory(category.id)}
                              >
                                <FiCheckCircle size={13} />
                              </Button>
                              <Button
                                variant="danger"
                                size="sm"
                                className="cm-action-btn"
                                title="Inactive"
                                onClick={() => inactiveCategory(category.id)}
                              >
                                <FiXCircle size={13} />
                              </Button>
                              <Button
                                variant="warning"
                                size="sm"
                                className="cm-action-btn cm-action-btn-edit"
                                title="Edit"
                                onClick={() => {
                                  setEditingCategory(true);
                                  setCategoryIdForUpdate(category.id);
                                  setName(category.category_name);
                                  setStatus(category.status);
                                  setImageForEdit(
                                    category.category_image || "",
                                  );
                                  setShowCatModal(true);
                                }}
                              >
                                <FiEdit2 size={13} />
                              </Button>
                              <Button
                                variant="outline-danger"
                                size="sm"
                                className="cm-action-btn"
                                title="Delete"
                                onClick={() => deleteCategory(category.id)}
                              >
                                <FiTrash2 size={13} />
                              </Button>
                              <Button
                                size="sm"
                                className="cm-action-btn cm-subcategory-btn"
                                title="Add Sub Category"
                                onClick={() => openSubCatModal(category)}
                              >
                                <FiPlusCircle size={13} />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    {!loading && filteredCategories.length === 0 && (
                      <tr>
                        <td colSpan="6" className="text-center py-5">
                          <div className="cm-empty-icon">🗂️</div>
                          <p className="cm-muted mt-2">No categories found</p>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          </section>
        </main>
      </div>

      {/* ── Create / Edit Modal ── */}
      <Modal
        show={showCatModal}
        onHide={handleCloseCatModal}
        centered
        size="md"
        className="cm-modal"
        backdropClassName="cm-modal-backdrop"
        backdrop="static"
        container={document.body}
        onEnter={() => {
          document.body.style.paddingRight = "0px";
          document.body.style.overflow = "hidden";
        }}
        onExited={() => {
          document.body.style.paddingRight = "";
          document.body.style.overflow = "";
        }}
      >
        <Modal.Header className="cm-modal-header-custom" closeButton={false}>
          <h2 className="cm-modal-title">
            {editingCategory ? "Edit Category" : "Create Category"}
          </h2>
          <button className="cm-modal-close-btn" onClick={handleCloseCatModal}>
            <FiX size={22} />
          </button>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {errorMessage && (
              <Alert
                variant="danger"
                className="py-2 px-3 mb-3"
                style={{ fontSize: "0.82rem" }}
              >
                {errorMessage}
              </Alert>
            )}
            <Form.Group className="cm-form-group-modal">
              <label className="cm-form-label-modal">
                <FiTag size={15} /> Category Name{" "}
                <span className="required">*</span>
              </label>
              <input
                type="text"
                value={name}
                onChange={(e) => {
                  setName(e.target.value);
                  setErrorMessage("");
                  setErrors((prev) => ({
                    ...prev,
                    name: regExpChecker("categoryName", e.target.value),
                  }));
                }}
                placeholder="e.g. Resin Art"
                className="cm-form-input-modal"
                required
              />
              {errors.name && (
                <small className="text-danger">{errors.name}</small>
              )}
            </Form.Group>
            <Form.Group className="cm-form-group-modal">
              <label className="cm-form-label-modal">
                <FiImage size={15} /> Category Image
              </label>
              {imageForEdit ? (
                <div className="cm-edit-image-preview">
                  <img
                    src={`${baseUrlForFiles}/${imageForEdit}`}
                    alt="current"
                    className="cm-modal-preview-img"
                  />
                  <span className="cm-muted" style={{ fontSize: "0.75rem" }}>
                    Current image — upload new to replace
                  </span>
                </div>
              ) : null}
              <input
                type="file"
                onChange={(e) => setImage(e.target.files[0])}
                className="cm-form-input-modal cm-file-input-modal"
                accept="image/*"
              />
            </Form.Group>
            <Form.Group className="cm-form-group-modal">
              <label className="cm-form-label-modal">Status</label>
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                className="cm-form-input-modal"
              >
                <option value="active">Active</option>
                <option value="inactive">Inactive</option>
              </select>
            </Form.Group>
            <div className="cm-form-actions-modal">
              <button
                type="button"
                className="cm-btn-cancel"
                onClick={handleCloseCatModal}
                disabled={submitLoading}
              >
                Cancel
              </button>
              <button
                type="button"
                className="cm-btn-submit"
                onClick={() => {
                  editingCategory ? updateCategory() : addCategory();
                }}
                disabled={submitLoading}
              >
                {submitLoading
                  ? editingCategory
                    ? "Updating..."
                    : "Creating..."
                  : editingCategory
                    ? "Update Category"
                    : "+ Create Category"}
              </button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ── Sub Category Modal ── */}
      {showSubCatModal && (
        <div className="cm-subcat-overlay">
          <div className="cm-subcat-modal card">
            <div className="card-body p-0">
              <div className="cm-subcat-header">
                <div>
                  <h5 className="cm-subcat-title">Add Sub Category</h5>
                  <p className="cm-subcat-subtitle">
                    Under:{" "}
                    <span className="cm-subcat-parent-name">
                      {parentCategoryName}
                    </span>
                  </p>
                </div>
                <button
                  className="cm-subcat-close"
                  onClick={closeSubCatModal}
                  disabled={subCatSubmitLoading}
                >
                  ✕
                </button>
              </div>
              <div className="cm-subcat-parent-badge">
                <span className="cm-subcat-dot" />
                <span>
                  Parent category: <strong>{parentCategoryName}</strong>
                </span>
              </div>
              <Form className="cm-form">
                {subCatError && (
                  <Alert
                    variant="danger"
                    className="py-2 px-3"
                    style={{ fontSize: "0.82rem" }}
                  >
                    {subCatError}
                  </Alert>
                )}
                <Form.Group className="cm-form-group">
                  <Form.Label className="cm-form-label">
                    Sub Category Name
                  </Form.Label>
                  <Form.Control
                    type="text"
                    value={subCatName}
                    onChange={(e) => {
                      setSubCatName(e.target.value);
                      setSubCatError("");
                    }}
                    placeholder="e.g. Epoxy Resin"
                    className="cm-form-input"
                  />
                </Form.Group>
                <div className="cm-btn-row">
                  <Button
                    className="cm-cancel-btn"
                    onClick={closeSubCatModal}
                    disabled={subCatSubmitLoading}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="cm-submit-btn"
                    onClick={createsubcategory}
                    disabled={subCatSubmitLoading}
                  >
                    {subCatSubmitLoading ? "Adding..." : "Add Sub Category"}
                  </Button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}

      <ToastContainer />
    </AdminMasterLayout>
  );
};

export default CategoryManagement;